module.exports = __webpack_public_path__ + "static/media/001_Start Screen Version 3@2x.fe9097fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/001_Start Screen Version 3@2x.png
// module id = 563
// module chunks = 0